import { Shape, Pagination, Flex, styled, Button } from '@teko/ds-desktop';
import { ForwardOutlined } from '@teko/ds-icon';
import { ProductGrid } from '../ProductGrid/ProductGrid.es.js';
import React from 'react';
import { t } from '../../i18n.es.js';
import { BlockHeader } from '../BlockHeader/BlockHeader.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const JustForYou = (_a) => {
  var _b = _a, {
    header,
    products,
    productsPerRow,
    pagination,
    isMobile,
    isLoading
  } = _b, rest = __objRest(_b, [
    "header",
    "products",
    "productsPerRow",
    "pagination",
    "isMobile",
    "isLoading"
  ]);
  if (!products || !products.length)
    return null;
  const hasMore = ((pagination == null ? void 0 : pagination.totalRecords) || 0) > ((pagination == null ? void 0 : pagination.currentPage) || 1) * ((pagination == null ? void 0 : pagination.pageLimit) || 0);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Wrapper, __spreadValues({}, rest), /* @__PURE__ */ React.createElement(BlockHeader, __spreadProps(__spreadValues({}, header), {
    title: header.title || t("S\u1EA3n ph\u1EA9m d\xE0nh cho b\u1EA1n")
  })), /* @__PURE__ */ React.createElement(ProductGrid, {
    products,
    productsPerRow: productsPerRow || (isMobile ? 2 : 5),
    regionName: "forYouListProduct"
  })), !isMobile && /* @__PURE__ */ React.createElement(Shape, {
    marginTop: "s16"
  }, /* @__PURE__ */ React.createElement(Pagination, __spreadProps(__spreadValues({}, pagination), {
    totalRecords: pagination == null ? void 0 : pagination.totalRecords,
    currentPage: pagination == null ? void 0 : pagination.currentPage
  }))), isMobile && hasMore && /* @__PURE__ */ React.createElement(Flex, {
    justify: "center",
    marginBottom: "s8"
  }, /* @__PURE__ */ React.createElement(ShowMoreButton, {
    variant: "link",
    suffix: /* @__PURE__ */ React.createElement(ForwardOutlined, null),
    disabled: isLoading,
    onClick: (e) => {
      var _a2;
      e == null ? void 0 : e.preventDefault();
      (_a2 = pagination == null ? void 0 : pagination.onPageChange) == null ? void 0 : _a2.call(pagination, ((pagination == null ? void 0 : pagination.currentPage) || 1) + 1);
    }
  }, t("Xem th\xEAm s\u1EA3n ph\u1EA9m"))));
};
JustForYou.displayName = "JustForYou";
const Wrapper = styled.div`
  background: white;
  border-radius: 0.5rem;
`;
const ShowMoreButton = styled(Button)`
  min-width: 250px;
  padding: 0.625rem 0.5rem;
  background-color: #fff;
  text-align: center;

  :active,
  :hover,
  :focus {
    text-decoration: none;
  }

  :active {
    color: ${({ theme }) => theme.colors.link500};
  }

  > div {
    display: unset;
  }
`;

export { JustForYou };
